import { VeiculoModel } from './../../app/models/VeiculoModel';
import { PreOrdemModel } from './../../app/models/PreOrdemModel';
import { FamiliaModel, ModeloModel } from './../../app/models/CardapioModel';
import { Injectable } from '@angular/core';
import { HttpProvider } from '../http/http';
import { ConfigHelper } from '../../app/helpers/configHelper';
import { Storage } from '@ionic/storage';
import { MarcaModeloModel } from '../../app/models/MarcaModeloModel';

@Injectable()
export class CardapioOnlineProvider {

  constructor(private httpSrv: HttpProvider,
    public storage: Storage) {
  }

  async getTodosCardapios(codConcessionaria: number, model: any = {}, loading: number = 1): Promise<Array<FamiliaModel>> {
    try {
      model.versaoapp = ConfigHelper.Version;
      let ResultConn = await this.httpSrv.post('acampav3/' + codConcessionaria, model, loading, 1, 'Atualização Encontrada! Realizando Download...', 300000);
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<FamiliaModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }

  async getCardapiosFast(codConcessionaria: number, model: any = {}, loading: number = 1): Promise<Array<FamiliaModel>> {
    try {
      model.versaoapp = ConfigHelper.Version;
      let ResultConn = await this.httpSrv.post('acampav3fast/' + codConcessionaria, model, loading, 1, 'Atualização Encontrada! Realizando Download...', 300000);
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<FamiliaModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }

  async getCardapios(codConcessionaria: number, model: any = {}, loading: number = 1): Promise<ModeloModel> {
    try {
      model.versaoapp = ConfigHelper.Version;
      let ResultConn = await this.httpSrv.post('acampav3cardapio/' + codConcessionaria, model, loading, 1, 'Baixando Oferta...',300000);
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <ModeloModel>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }

  async getMarcaModelo(Projeto: number): Promise<Array<MarcaModeloModel>> {
    try {
      let ResultConn = await this.httpSrv.get('marcamodelo/' + Projeto, 1, 'Atualização Encontrada! Realizando Download...', null, 300000);
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<MarcaModeloModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }


  async getPacotesTrocaOleo(codConcessionaria: number, _carroversao: any): Promise<ModeloModel> {
    try {
      let ResultConn = await this.httpSrv.post('acampatrocaoleo/' + codConcessionaria,  _carroversao, 1, 1);
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        console.log('providers',ResultConn.data);
        return <ModeloModel>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }


  async getImprimirCardapioPdf(_cardapio: any, _codConcessionaria: number): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.post('imprimirCardapioPdf/'+_codConcessionaria, _cardapio, 1, 1);
      if (ResultConn) {
        if (ResultConn.success) {
          return <any>ResultConn.data;
        }
      }
    } catch (error) {
      console.log('problema ao carregar os todos os cardapios online', error);
    }
  }
  



  async getServicosPersonalizados(): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.getLocal('assets/data/servicospersonalizados.json');
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os servicos personalizados', error);
    }
  }

  async getServicosPersonalizadoByCodigo(extra: number): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.getLocal('assets/data/servicospersonalizados.json');
      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        let dados = <Array<any>>ResultConn.data;

        let result = dados.find(dado => dado.codigo == extra);

        return result;
      }
    } catch (error) {
      console.log('problema ao carregar os servicos personalizados', error);
    }
  }

  async getPlaca(cnpj: string, placa: string, dms: number, urlintegracao: string, chassi:string): Promise<VeiculoModel> {

    if(!urlintegracao)
    {
      urlintegracao = "https://dms.camptecnologia.com.br/";
    }
    
    let nomedms = "";
      
    if(dms == 1)
      nomedms = "dealernet";
    else if(dms == 2)
      nomedms = "apollo";
    else if(dms == 3)
      nomedms = "nbs";
    else if(dms == 4)
      nomedms = "sisdia";
    else if(dms == 5)
      nomedms = "sercon";
    else if(dms == 6)
      nomedms = "siare";
    else if(dms == 7)
      // nomedms = "workflow";
      nomedms = "API-WorkFlow";
    else if(dms == 8)
      nomedms = "camp";
    else if(dms == 9)
      nomedms = "gaia";
    else if(dms == 10)
      nomedms = "API-WorkFlow";
    else if(dms == 11)
      nomedms = "API-Apollo";
    else if(dms == 12)
      nomedms = "API-NBS";


    let form: any = {};
    form.dmsnome = nomedms;
    form.dms = dms;
    form.placa = placa;
    form.chassi = chassi;

    try {

      let ResultConn;
      if(dms == 7 || dms == 10 || dms == 11 || dms == 12)
      {
        ResultConn = await this.httpSrv.postDmsCamp('consultarVeiculo/' + cnpj, JSON.stringify(form), 1,"Carregando os dados...",false, 3, 25000);
      }
      else
      {
        ResultConn = await this.httpSrv.getDms(urlintegracao+'placa/' + cnpj + '/' + placa + '/' + nomedms,1,"Carregando os dados...",true, 3, 25000);
      }

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <VeiculoModel>ResultConn.data;
      }
      if(!ResultConn.success){
        return ResultConn.err.error;
      }
    } catch (error) {
      console.log('problema ao carregar as busca placa online dms:'+dms, error);
    }
  }

  async getChassi(cnpj: string, chassi: string, dms: number, urlintegracao: string): Promise<VeiculoModel> {

    if(!urlintegracao)
    {
      urlintegracao = "https://dms.camptecnologia.com.br/";
    }
    
    let nomedms = "";
      
    if(dms == 1)
      nomedms = "dealernet";
    else if(dms == 2)
      nomedms = "apollo";
    else if(dms == 3)
      nomedms = "nbs";
    else if(dms == 4)
      nomedms = "sisdia";
    else if(dms == 5)
      nomedms = "sercon";
    else if(dms == 6)
      nomedms = "siare";
    else if(dms == 7)
      nomedms = "workflow";
    else if(dms == 8)
      nomedms = "camp";
    else if(dms == 9)
      nomedms = "gaia";
    else if(dms == 10)
      nomedms = "API-WorkFlow";
    else if(dms == 11)
      nomedms = "API-Apollo";
    else if(dms == 12)
      nomedms = "API-NBS";


    let form: any = {};
    form.dmsnome = nomedms;
    form.dms = dms;
    form.chassi = chassi;

    try {

      let ResultConn;
      if(dms == 10 || dms == 11 || dms == 12)
      {
        ResultConn = await this.httpSrv.postDmsCamp('consultarVeiculo/' + cnpj, JSON.stringify(form), 1,"Carregando os dados...",false, 3, 25000);
      }
      else
      {
        ResultConn = await this.httpSrv.getDms(urlintegracao+'chassi/' + cnpj + '/' + chassi + '/' + nomedms,1,"Carregando os dados...",true, 3, 25000);
      }

      //console.log('ResultConn',ResultConn);
      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <VeiculoModel>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as busca chassi online dms:'+dms, error);
    }
  }

  async getAgendamento(cnpj: string, dias: number, dms: number, urlintegracao: string, atualizaInstantaneamente: boolean = false, placa:string = ""): Promise<Array<VeiculoModel>> {

    if(!urlintegracao)
    {
      urlintegracao = "https://dms.camptecnologia.com.br/";
    }

    let nomedms = "";
      
    if(dms == 1)
      nomedms = "dealernet";
    else if(dms == 2)
      nomedms = "apollo";
    else if(dms == 3)
      nomedms = "nbs";
    else if(dms == 4)
      nomedms = "sisdia";
    else if(dms == 5)
      nomedms = "sercon";
    else if(dms == 6)
      nomedms = "siare";
    else if(dms == 7)
      nomedms = "workflow";
    else if(dms == 8)
      nomedms = "camp";
    else if(dms == 9)
      nomedms = "gaia";
    else if(dms == 10)
      nomedms = "API-WorkFlow";
    else if(dms == 11)
      nomedms = "API-Apollo";
    else if(dms == 12)
      nomedms = "API-NBS";


    let form: any = {};
    form.dmsnome = nomedms;
    form.dms = dms;
    form.dias = dias;

    try {
      let ResultConn;

      var msg = "Carregando os dados...";
      if(dms == 10 || dms == 11 || dms == 12)
      {
        if(placa!=""){
          msg = "Pesquisando placa no intervalo de 30 dias..."
          form.placa = placa;
        } 
        ResultConn = await this.httpSrv.postDmsCamp('listarAgendamentos/' + cnpj  + (atualizaInstantaneamente?"/1":""), JSON.stringify(form), 1,msg,false, 3, 25000);
      }
      else
      {
        ResultConn = await this.httpSrv.getDms(urlintegracao+'agendamento/' + cnpj + '/' + dias+ '/' + nomedms + (atualizaInstantaneamente?"/1":""),1,msg,false, 3, 25000);
      }

      //console.log('ResultConn',ResultConn);

      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <Array<VeiculoModel>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar as busca placa dealernet online', error);
    }
  }


  async getCliente(cnpj: string, registro: any, dms: number, urlintegracao: string): Promise<VeiculoModel> {

    if(!urlintegracao)
    {
      urlintegracao = "https://dms.camptecnologia.com.br/";
    }

    let nomedms = "";
      
    if(dms == 1)
      nomedms = "dealernet";
    else if(dms == 2)
      nomedms = "apollo";
    else if(dms == 3)
      nomedms = "nbs";
    else if(dms == 4)
      nomedms = "sisdia";
    else if(dms == 5)
      nomedms = "sercon";
    else if(dms == 6)
      nomedms = "siare";
    else if(dms == 7)
      nomedms = "workflow";
    else if(dms == 8)
      nomedms = "camp";
    else if(dms == 9)
      nomedms = "gaia";
    else if(dms == 10)
      nomedms = "API-WorkFlow";
    else if(dms == 11)
      nomedms = "API-Apollo";
    else if(dms == 12)
      nomedms = "API-NBS";

    let form: any = {};
    form.dmsnome = nomedms;
    form.dms = dms;
    form.cpfcpnpj = registro.cpfcpnpj;
    form.codcliente = registro.codcliente;
    form.placa = registro.placa;
    form.codveiculo = registro.codveiculo;

    try {
      let ResultConn;

      if(dms == 7 || dms == 10 || dms == 11 || dms == 12)
      {
        ResultConn = await this.httpSrv.postDmsCamp('consultarCliente/' + cnpj, JSON.stringify(form), 1,"Carregando os dados...",false, 1, 15000);
      }
      else
      {
        if(registro.cpfcpnpj)
        {
          ResultConn = await this.httpSrv.getDms(urlintegracao+'cliente/' + cnpj + '/' + registro.cpfcpnpj+ '/' + nomedms,1,"Carregando os dados...",false, 1, 15000);
        }
      }

      //console.log('ResultConn',ResultConn);

      if (ResultConn.success) {
        //console.log('providers',ResultConn.data);
        return <VeiculoModel>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao carregar os dados do cliente', error);
    }
  }

  async setOrdemServico(model: PreOrdemModel): Promise<Array<any>> {
    try {
      let ResultConn = await this.httpSrv.post('ordemservico', model, 0, 0);
      if (ResultConn.success) {
        return <Array<any>>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar a ordem de servico', error);
    }
  }

  async setPreOs(model: PreOrdemModel): Promise<number> {
    try {
      let ResultConn = await this.httpSrv.post('preordem/'+ConfigHelper.Distribuidor, model, 1, 1);
      //let ResultConn = await this.httpSrv.postStorage('preordem', model, 1, 1);
      if (ResultConn.success) {
        return <number>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao enviar o preos', error);
    }
  }

  async isCardapios(): Promise<any> {
    var cardapioCompleto;
    var cardapio1 = null, cardapio2 = null;
     cardapio1 = await this.storage.get(ConfigHelper.storageKeys.cardapios1);
     cardapio2 = await this.storage.get(ConfigHelper.storageKeys.cardapios2);
    if(cardapio1 && cardapio2 && JSON.parse(cardapio1).length > 0){
      cardapio1 = cardapio1.slice(0, cardapio1.length - 1);
      cardapio2 = cardapio2.slice(1, cardapio2.length);
      
      cardapioCompleto = cardapio1 + "," + cardapio2;
    }else if(JSON.parse(cardapio1) && JSON.parse(cardapio1).length == 0){
      cardapioCompleto = cardapio2;
    }else{ //logica para pegar o cardapio da forma antiga, para não atrapalhar o funcionamento de quem nao atualizar dados na nova versao
     cardapio1 = await this.storage.get(ConfigHelper.storageKeys.cardapios1.slice(0,ConfigHelper.storageKeys.cardapios1.length-1));
    cardapioCompleto = cardapio1;
    }
    
    
    return cardapioCompleto;
  }


  async isMarcaModelo(): Promise<any> {
    return await this.storage.get(ConfigHelper.storageKeys.marcamodelo);
  }

  async setAcampaAtualizacao(form: any): Promise<any> {
    try {
      let dataNotificacao = null;
      const arrayDataNotificacao = await this.storage.get(ConfigHelper.storageKeys.dataNotificacao);
      const codConcessionaria = await this.storage.get(ConfigHelper.storageKeys.codConcessionaria);
      if(Array.isArray(arrayDataNotificacao)){
         dataNotificacao = arrayDataNotificacao.filter((concessionaria) => concessionaria.codConcessionaria == codConcessionaria)
        }
      form.dataNotificacao = dataNotificacao && dataNotificacao[0].data?dataNotificacao[0].data : null;
      let ResultConn = await this.httpSrv.post('acampaatualizacao', form, 0, 1, 'Buscando Atualização...', 5000);
      if (ResultConn) {
        console.log("🚀 ~ CardapioOnlineProvider ~ setAcampaAtualizacao ~ dataNotificacao:", dataNotificacao)
        if (ResultConn.success) {
            if(ResultConn.data.data){
              if(dataNotificacao && dataNotificacao[0].data){
                dataNotificacao[0].data = ResultConn.data.data;
              }else{
                dataNotificacao = [
                  {
                    codConcessionaria: codConcessionaria,
                    data: ResultConn.data.data
                  }
                ]
              }
            this.storage.set(ConfigHelper.storageKeys.dataNotificacao, arrayDataNotificacao);
          }
          return <any>ResultConn.data;
        }
      }
    } catch (error) {
      console.log('problema ao carregar as acampa atualizacao online', error);
    }
  }


  async setLog(form: any): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.post('acampalog', form, 0, 1, 'Buscando Atualização...', 5000);
      if (ResultConn) {
        if (ResultConn.success) {
          return <any>ResultConn.data;
        }
      }
    } catch (error) {
      console.log('problema ao carregar as acampa log online', error);
    }
  }

  async getImagensGrupos(codConcessionaria: number, data: string): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.post('artegrupos/' + codConcessionaria , data, 0, 1,'Buscando imagens...', 300000);
      if (ResultConn) {
        if (ResultConn.success) {
          return <any>ResultConn.data;
        }
      }
    } catch (error) {
      console.log('problema ao carregar as imagens', error);
    }
  }

  async consultaRecall(chassi: string, marca: string): Promise<any> {
    try {
      let ResultConn = await this.httpSrv.postCamp('consultarecall', {"chassi":chassi, "marca": marca});
      if (ResultConn.success) {
        return <any>ResultConn.data;
      }
    } catch (error) {
      console.log('problema ao consultar recall', error);
    }
  }

}


// WEBPACK FOOTER //
// ./src/providers/cardapio-online/cardapio-online.ts